import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { ItemErrorComponent } from '../../components/item-form-error/item-form-error.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import ServiceRestServices from '../../services/service-rest.service';
import Toast from '../../services/toast.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import RoutingService from '../../services/routing.service';
import { MatSelectModule } from '@angular/material/select';
import { PanelDirective } from '../../directives/panel.directive';

@Component({
	standalone: true,
	selector: 'settings',
	templateUrl: './settings.component.html',
	imports: [ CommonModule, PanelDirective, MatSelectModule, TranslatePipe, LoaderOverlayComponent, ItemErrorComponent, FormsModule ]
})
export default class SettingsView implements OnInit {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private toast: Toast = inject(Toast);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('settings').then(() => {
			this.onResolve();
		});
	}
	
	onResolve() {
		this.initialize();
		
		this.vm.getCounties = this.getCounties;
		this.vm.handleSubmit = this.handleSubmit;
	}
	
	initialize() {
		this.vm.processing = true;
		this.vm.user = this.session.getSession().user;
		this.vm.countries = this.config.getCountries();
		this.vm.showLicenseNumber = this.vm.user.businessUserType === 'SERVICE_OWNER';
		this.vm.title = this.vm.user.businessUserType === 'SERVICE_OWNER'
			? this.angularFilterHelperService.translate('Subscription.Title.Service_Contact')
			: this.angularFilterHelperService.translate('Subscription.Title.Business_Contact');
		
		this.serviceRestServices.getServiceByUserId({ userId: this.vm.user.id }, (service) => {
			this.vm.data = service;
			this.getCounties();
			this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
			this.angularHelperService.createTimer(() => {
				this.vm.initialized = true;
				this.vm.processing = false;
			}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
		});
	}
	
	handleSubmit(mainForm: any) {
		if (this.vm.processing) return;
		this.vm.submitted = true;
		if (mainForm.invalid || !this.vm.data.contact.country) return;
		this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
		this.vm.processing = true;
		this.vm.loaderTimeout = this.angularHelperService.createTimer(() => { this.vm.processing = true; },
			this.config.getOtherConfig().LOADER_TIMEOUT_INIT);
		
		this.serviceRestServices.postSignUpTwo(this.vm.data, (res) => {
			this.session.getSession().user.service = res;
			this.angularHelperService.createTimer(() => {
				this.toast.showWithTranslation('Toast.Profile.Updated_Service');
				this.angularRoutingHelperService.goHomeAndKeepHistory(this.session.getSession() ? this.session.getSession().user : null);
			}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
		});
	}
	
	getCounties() {
		this.vm.data = this.vm.data || {};
		this.vm.data.contact = this.vm.data.contact || {};
		this.vm.counties = this.config.getCounties(this.vm.data.contact.country);
		if (this.vm.data.contact.state) return;
		if (this.vm.data.contact.country === 'Estonia') {
			this.vm.data.contact.state = this.vm.counties[0];
		} else {
			this.vm.data.contact.state = null;
		}
	}
	
}